<template>
  <div>
    <section>
      <p>Picked the wrong subscription? Shop around then come back to pay!</p>
    </section>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
